export default "__VITE_ASSET__8KdNtR_p__"